var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.awardContainer
  }, [_c('RouterLink', {
    attrs: {
      "to": {
        name: 'awards',
        query: {
          awardId: _vm.award.id
        }
      }
    }
  }, [_c('img', {
    class: _vm.$style.awardPicture,
    attrs: {
      "src": _vm.imageUrl,
      "alt": ""
    },
    on: {
      "error": _vm.handleImageError
    }
  })]), _c('div', {
    class: _vm.$style.awardInfo
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('h3', {
    staticClass: "color-primary-blue font-weight-bold"
  }, [_vm._v(_vm._s(_vm.award.title))]), _c('p', {
    staticClass: "button-text color-darkest-gray"
  }, [_vm._v(_vm._s(_vm.award.year))])]), _c('p', {
    staticClass: "p1 color-primary-blue"
  }, [_vm._v(_vm._s(_vm.award.description))])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }